<template>
    <v-btn
        icon
        href="https://www.facebook.com/BayHouseGrenada/"
        target="_blank"
    >
        <v-icon size="50">
            mdi-facebook
        </v-icon>
    </v-btn>
</template>
<script>
export default {
    name: "facebook"
}
</script>
<style scoped>

</style>